import React, { useState } from 'react';
import Landing from './components/Landing';
import ApiKeyModal from './components/ApiKeyModal';
import AssessmentForm from './components/AssessmentForm';
import Loading from './components/Loading';
import Results from './components/Results';
import { submitAssessment } from './utils/api';

const VIEWS = { LANDING: 'landing', FORM: 'form', LOADING: 'loading', RESULTS: 'results' };

export default function App() {
  const [view, setView] = useState(VIEWS.LANDING);
  const [showModal, setShowModal] = useState(false);
  const [apiKey, setApiKey] = useState(localStorage.getItem('sentinel_api_key') || '');
  const [formData, setFormData] = useState({});
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');

  const handleStart = () => {
    if (!apiKey) { setShowModal(true); return; }
    setView(VIEWS.FORM);
  };

  const handleApiKey = (k) => {
    setApiKey(k);
    setShowModal(false);
    setView(VIEWS.FORM);
  };

  const handleChange = (key, val) => setFormData(prev => ({ ...prev, [key]: val }));

  const handleSubmit = async () => {
    setError('');
    setView(VIEWS.LOADING);
    try {
      const data = await submitAssessment(formData, apiKey);
      setResults(data);
      setView(VIEWS.RESULTS);
    } catch (err) {
      setError(err.message || 'Assessment failed. Please check your API key and try again.');
      setView(VIEWS.FORM);
    }
  };

  const handleReset = () => { setView(VIEWS.LANDING); setFormData({}); setResults(null); setError(''); };

  return (
    <>
      {error && (
        <div style={{ position: 'fixed', top: 76, left: '50%', transform: 'translateX(-50%)', background: 'rgba(244,63,94,.14)', border: '1px solid rgba(244,63,94,.4)', borderRadius: 12, padding: '13px 22px', fontFamily: 'var(--ff-mono)', fontSize: 13, color: '#f43f5e', zIndex: 9100, maxWidth: 520, textAlign: 'center', backdropFilter: 'blur(12px)' }}>
          ⚠ {error}
          <button onClick={() => setError('')} style={{ marginLeft: 14, background: 'none', border: 'none', color: '#f43f5e', cursor: 'pointer', fontSize: 14 }}>✕</button>
        </div>
      )}
      {showModal && <ApiKeyModal onConfirm={handleApiKey} onCancel={() => setShowModal(false)} />}
      {view === VIEWS.LANDING  && <Landing onStart={handleStart} />}
      {view === VIEWS.FORM     && <AssessmentForm formData={formData} onChange={handleChange} onSubmit={handleSubmit} isLoading={false} />}
      {view === VIEWS.LOADING  && <Loading companyName={formData.companyName} />}
      {view === VIEWS.RESULTS  && results && <Results data={results} onReset={handleReset} />}
    </>
  );
}
